import { CollectionEntity } from "@busy-human/gearbox";
export var PairChangeRecord;
(function (PairChangeRecord) {
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return {
                builderId: "",
                before: "",
                after: "",
                changedFields: [],
                linesUp: false,
                changedAt: new Date().toISOString(),
                seasonId: ""
            };
        }
    }
    PairChangeRecord.CollectionClass = CollectionClass;
    PairChangeRecord.Collection = new CollectionClass({ path: "PairChangeRecord" });
})(PairChangeRecord || (PairChangeRecord = {}));
//# sourceMappingURL=index.js.map